module.exports = __webpack_public_path__ + "static/media/EDS - Logo Air Technology.5f68978c.png";